import React from 'react';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import Box from '@mui/material/Box';
import logo from '../../styles/countrywide-logo-white.svg';

const theme = createTheme({
  palette: {
    primary: {
      main: '#4e2157', // Purple color
    },
    secondary: {
      main: '#1976d2', // Blue color
    },
  },
});

const NavBar = () => {
  return (
    <ThemeProvider theme={theme}>
      <AppBar position="static" color="primary" sx={{boxShadow:'0px 5px 2px -2px grey', }}>
        <Toolbar sx={{ marginY:1,  }}>
          <Typography variant="h6" color="white" sx={{ flexGrow: 1 }}>
            CSS Quality Shield Portal
          </Typography>
          <Box
            component="img"
            sx={{
              height: 40,
            }}
            alt="Countrywide Logo"
            src={logo}
          />
        </Toolbar>
      </AppBar>
    </ThemeProvider>
  );
};

export default NavBar;